module.exports = __webpack_public_path__ + "assets/img/17_1042.3e126c46.jpg";